/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";

import "../../App.css";
import { Card, Form, Select, Checkbox } from "antd";
import Jax from "../../Jax/jax.es6.module";
import TableIDs from "../../data/TableIDs";
import { DatePicker, TimePicker } from 'antd';
import moment from "moment";
import PageToolbar from "../../components/PageToolbar";
import LangContext from "../../contextProvider/LangContext";
import ReportTypeButton from "../../components/ReportTypeButton";
import { disabledDatePicker } from "../../utils/utils";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";

const FormItem = Form.Item;
const { Option, OptGroup } = Select;

type Props = {
    user: any,
    ui: any,
    uiActions: any,
    baseUrl: string,
    data: Object,
    dataActions: Object,
    ActionQueue: any
};
type State = {};

class PaymentDailyReport extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            endOpen: false,
            PaymentDaily: {
                PaymentType: '',
                StorageList: '',
                ItemTagList: '',
                EmployeeList: '',
                PosList: '',
                LowerSelectionDate: moment().add(-1, "month").format("YYYY-MM-01"),
                UpperSelectionDate: moment().format("YYYY-MM-DD"),
                LowerSelectionTime: '00:00:00',
                UpperSelectionTime: '23:59:59',
                reportName: "reports/paymentsDaily.pdf",
            }
        };

        this.state.type = "pdf";
        this.state.RequestedReport = "Tags"; // Tags // Suppliers

        if (props.data[TableIDs.genericSelectorPos] === undefined) {
            props.data[TableIDs.genericSelectorPos] = { ...props.data.genericSelector };
        }
        //if (props.data[TableIDs.genericSelectorEmployees] === undefined) {
        //    props.data[TableIDs.genericSelectorEmployees] = { ...props.data.genericSelector };
        //}
        if (props.data[TableIDs.genericMultiSelectorItemTags] === undefined) {
            props.data[TableIDs.genericMultiSelectorItemTags] = { ...props.data.genericSelector };
        }
        if (props.data[TableIDs.genericSelectorStorages] === undefined) {
            props.data[TableIDs.genericSelectorStorages] = { ...props.data.genericSelector };
        }
        if (props.data[TableIDs.genericSelectorItemGroup] === undefined) { //////
            props.data[TableIDs.genericSelectorItemGroup] = { ...props.data.genericSelector };
        }
        if (props.data[TableIDs.genericSelectorItemTagTypes] === undefined) { //////
            props.data[TableIDs.genericSelectorItemTagTypes] = { ...props.data.genericSelector };
        }
        if (props.data[TableIDs.genericSelectorPaymentTypes] === undefined) { //////
            props.data[TableIDs.genericSelectorPaymentTypes] = { ...props.data.genericSelector };
        }
        //if (props.data[TableIDs.genericSelectorSuppliers] === undefined) {
        //    props.data[TableIDs.genericSelectorSuppliers] = { ...props.data.genericSelector };
        //}

        this.api = {
            selector_pos: "list_pos",
            selector_employees: "get_employee_list",
            selectorMulti_itemtag: "get_tags_with_types",
            selector_storages: "get_storage_list",
            selector_item_tagTypes: "get_tag_types_with_relation_list",//
            selector_item_group: "get_item_group_list",
            selector_supplier: "get_suppliers",
            selector_payment_types: "get_payment_types_list",
        }

        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorPos, this.props.user.companyCode, this.props.user.token, this.api.selector_pos);
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorEmployees, this.props.user.companyCode, this.props.user.token, this.api.selector_employees);
        this.props.dataActions.genericMultiSelectorRefreshDataset(
            TableIDs.genericMultiSelectorItemTags, this.props.user.companyCode, this.props.user.token, this.api.selectorMulti_itemtag);
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorStorages, this.props.user.companyCode, this.props.user.token, this.api.selector_storages);
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorItemTagTypes, this.props.user.companyCode, this.props.user.token, this.api.selector_item_tagTypes);//
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorItemGroup, this.props.user.companyCode, this.props.user.token, this.api.selector_item_group); //
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorPaymentTypes, this.props.user.companyCode, this.props.user.token, this.api.selector_payment_types); //

        //this.props.dataActions.genericSelectorRefreshDataset(
        //    TableIDs.genericSelectorSuppliers, this.props.user.companyCode, this.props.user.token, this.api.selector_supplier);
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.loadData();
    }

    setReportParameters(report: string, params: Object) {
        let newState = Jax.mutate(this.state || {}, report, params);
        this.setState(newState);
    }

    generateReport(report: string) {
        let params = Jax.get(this.state || {}, report, null);
        if (params !== null && params.reportName) {
            window.console.log("Generating report...");
            params = this.getFullSelector(params);
            params = { ...params, REPORT_LOCALE: this.getText(101) }
            this.props.ActionQueue.addToQueue({ action: this.props.dataActions.generateReport, args: [this.props.user.companyCode, this.props.user.token, params] });
        }
    }

    getFullSelector = (params) => {
        let fullPosList = this.props.data[TableIDs.genericSelectorPos].dataset.map((obj) => obj['code']).join(',');
        let fullStoragesList = this.props.data[TableIDs.genericSelectorStorages].dataset.map((obj) => obj['code']).join(',');
        if (params.PosList === '') params = { ...params, PosList: fullPosList }
        if (params.StorageList === '') params = { ...params, StorageList: fullStoragesList }
        return params;
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(10189);
        let posList = this.props.data[TableIDs.genericSelectorPos];
        let storagesList = this.props.data[TableIDs.genericSelectorStorages];

        if (
            posList && posList.dataset[0]
            &&
            storagesList && storagesList.dataset[0]
            && !this.state.loading
        ) {
            this.setState({ loading: true })
        }

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setReportParameters("PaymentDaily", this.props.ui.favoriteParams)
        }

    }

    loadData() {
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorPos, this.props.user.companyCode, this.props.user.token, this.api.selector_pos]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorEmployees, this.props.user.companyCode, this.props.user.token, this.api.selector_employees]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericMultiSelectorRefreshDataset,
            args: [TableIDs.genericMultiSelectorItemTags, this.props.user.companyCode, this.props.user.token, this.api.selectorMulti_itemtag]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorStorages, this.props.user.companyCode, this.props.user.token, this.api.selector_storages]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorItemTagTypes, this.props.user.companyCode, this.props.user.token, this.api.selector_item_tagTypes]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorItemGroup, this.props.user.companyCode, this.props.user.token, this.api.selector_item_group]
        });
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorPaymentTypes, this.props.user.companyCode, this.props.user.token, this.api.selector_payment_types]
        });
        //this.props.ActionQueue.addToQueue({
        //    action: this.props.dataActions.genericSelectorRefreshDataset,
        //    args: [TableIDs.genericSelectorSuppliers, this.props.user.companyCode, this.props.user.token, this.api.selector_supplier]
        //});
    }
    disabledStartDate = (FromDate) => {
        const ToDate = this.state.PaymentDaily.LowerSelectionDate;
        if (!FromDate || !ToDate) {
            return false;
        }
        return FromDate.valueOf() > ToDate.valueOf();
    }

    disabledEndDate = (ToDate) => {
        const FromDate = this.state.PaymentDaily.UpperSelectionDate;
        if (!ToDate || !FromDate) {
            return false;
        }
        return ToDate.valueOf() <= FromDate.valueOf();
    }


    onChange = (field, value) => {
        this.setReportParameters("PaymentDaily", { [field]: value })
        //this.setState({
        //    [field]: value,
        //});
    }

    onStartChange = (value) => {
        this.setReportParameters("PaymentDaily", {
            LowerSelectionDate: value ? value.format("YYYY-MM-DD") : null,
            LowerSelectionTime: value ? value.format("HH:mm:ss") : null,
        })
        // this.onChange('LowerSelectionDate', value ? value.format("YYYY-MM-DD") : null);
        // this.onChange('LowerSelectionTime', value ? value.format("hh:mm:ss") : null);
        // this.onChange('LowerSelectionDate', value ? value.format("D/M/YY") : null);
        // this.onChange('LowerSelectionTime', value ? value.format("HH:mm") : null);
    }

    onEndChange = (value) => {
        this.setReportParameters("PaymentDaily", {
            UpperSelectionDate: value ? value.format("YYYY-MM-DD") : null,
            UpperSelectionTime: value ? value.format("HH:mm:ss") : null,
        })
        // this.onChange('UpperSelectionDate', value ? value.format("YYYY-MM-DD") : null);
        // this.onChange('UpperSelectionTime', value ? value.format("hh:mm:ss") : null);
        // this.onChange('UpperSelectionDate', value ? value.format("D/M/YY") : null);
        // this.onChange('UpperSelectionTime', value ? value.format("HH:mm") : null);
    }
    /*
    handleStartOpenChange = (open) => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    }

    handleEndOpenChange = (open) => {
        this.setState({ endOpen: open });
    }*/
    createCheckBox = (field, data) => {
        return (
            <Checkbox
                style={{ display: 'inline' }}
                onChange={(e) => {
                    if (e.target.checked)
                        this.setReportParameters("PaymentDaily", { [field]: data });
                    else
                        this.setReportParameters("PaymentDaily", { [field]: '' });
                }} />);
    }

    render() {
        const { PaymentDaily, endOpen } = this.state;
        const { LowerSelectionDate, LowerSelectionTime,
            UpperSelectionDate, UpperSelectionTime } = PaymentDaily;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        //const { PaymentDaily } = this.state;
        const isMinPercShownStyle = { display: (PaymentDaily.RequestedReport === 5 || PaymentDaily.RequestedReport === 6) ? 'block' : 'none' }

        let listPos = Jax.get(this.props.data, TableIDs.genericSelectorPos + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']} valuefilter={obj['name']}>{obj['code'] + '-' + obj['name']}</Option>)
        });
        let listEmployee = Jax.get(this.props.data, TableIDs.genericSelectorEmployees + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']} valuefilter={obj['name']}>{obj['code'] + '-' + obj['name']}</Option>)
        });

        let listItemTags = Jax.get(this.props.data, TableIDs.genericMultiSelectorItemTags + ".dataset", []).map(
            (node: TagObj, index) => {
                return (
                    <OptGroup label={node.type.text} key={"type_" + node.type.id}>
                        {node.tags.map((item: string, index) => {
                            return (<Option key={"tag_" + item.id} value={item.id} valuefilter={item.text}>{item.text}</Option>)
                        })}
                    </OptGroup>
                )
            }
        )

        let listStorage = Jax.get(this.props.data, TableIDs.genericSelectorStorages + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']} valuefilter={obj['name']}>{obj['code'] + '-' + obj['name']}</Option>)
        });
        let listItemTagTypes = Jax.get(this.props.data, TableIDs.genericSelectorItemTagTypes + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']} valuefilter={obj['name']}>{obj['code'] + '-' + obj['name']}</Option>)
        });
        let listItemGroup = Jax.get(this.props.data, TableIDs.genericSelectorItemGroup + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']} valuefilter={obj['name']}>{obj['code'] + '-' + obj['name']}</Option>)
        });
        //let listSuppliers = Jax.get(this.props.data, TableIDs.genericSelectorSuppliers + ".dataset", []).map((obj, index) => {
        //    return (<Option key={obj['code']} value={obj['code']}>{obj['code'] + '-' + obj['name']}</Option>)
        //});
        let listPayments = Jax.get(this.props.data, TableIDs.genericSelectorPaymentTypes + ".dataset", []).map((obj, index) => {
            return (<Option key={obj['code']} value={obj['code']} valuefilter={obj['name']}>{obj['code'] + '-' + obj['name']}</Option>)
        });

        let mobile = window.innerWidth > 600 ? false : true;

        return (
            <div style={divStyle} >
                <Card title={(<PageToolbar title={this.getText(12152)} showsearch={false} actionButtons={[]} />)}
                    bordered={true} style={{ width: mobile ? '95%' : '60%' }}
                    headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}>

                    <Form className="data-entry-form" layout='horizontal' //layout='vertical' //'horizontal' // inline  |'vertical'|'inline'
                        style={{ columnWidth: 'auto', columnCount: mobile ? '1' : '2', paddingTop: mobile ? 50 : 0 }}
                        onSubmit={this.handleSaveChanges}
                    >

                        <FormItem label={this.getText(12153)} /*LowerSelectionDate - LowerSEleCtionTime*/>
                            <DatePicker
                                disabledDate={d => disabledDatePicker(d,
                                    this.state.PaymentDaily.UpperSelectionDate ?
                                        moment(this.state.PaymentDaily.UpperSelectionDate).add(-370, "days").format("YYYY-MM-DD")
                                        : null,
                                    this.state.PaymentDaily.UpperSelectionDate)}
                                //  disabledDate={this.disabledStartDate}
                                // showTime
                                format="DD-MM-YYYY"//"YYYY-MM-DD"
                                //format="D/M/YY"
                                value={this.state.PaymentDaily.LowerSelectionDate ? moment(this.state.PaymentDaily.LowerSelectionDate, "YYYY-MM-DD") : null}
                                placeholder={this.getText(12164)}
                                onChange={(value) => {
                                    this.setReportParameters("PaymentDaily", {
                                        LowerSelectionDate: value ? value.format("YYYY-MM-DD") : null,
                                    })
                                }}
                            />
                            <TimePicker
                                format="HH:mm:ss"
                                value={this.state.PaymentDaily.LowerSelectionTime ? moment(this.state.PaymentDaily.LowerSelectionTime, "HH:mm:ss") : null}
                                onChange={(value) => {
                                    this.setReportParameters("PaymentDaily", {
                                        LowerSelectionTime: value ? value.format("HH:mm:ss") : null,
                                    })
                                }}
                            />

                        </FormItem>
                        <FormItem label={this.getText(12154)} /*style={isEndDateShownStyle}*/>
                            <DatePicker
                                disabledDate={d => disabledDatePicker(d,
                                    this.state.PaymentDaily.LowerSelectionDate,
                                    this.state.PaymentDaily.LowerSelectionDate ?
                                        moment(this.state.PaymentDaily.LowerSelectionDate).add(370, "days").format("YYYY-MM-DD")
                                        : null)}
                                //    disabledDate={this.disabledEndDate}
                                // showTime
                                format="DD-MM-YYYY"//"YYYY-MM-DD"
                                //format="D/M/YY"
                                value={this.state.PaymentDaily.UpperSelectionDate ? moment(this.state.PaymentDaily.UpperSelectionDate, "YYYY-MM-DD") : null}
                                placeholder={this.getText(12165)}
                                onChange={(value) => {
                                    this.setReportParameters("PaymentDaily", {
                                        UpperSelectionDate: value ? value.format("YYYY-MM-DD") : null,
                                    })
                                }}
                            />
                            <TimePicker
                                format="HH:mm:ss"
                                value={this.state.PaymentDaily.UpperSelectionTime ? moment(this.state.PaymentDaily.UpperSelectionTime, "HH:mm:ss") : null}
                                onChange={(value) => {
                                    this.setReportParameters("PaymentDaily", {
                                        UpperSelectionTime: value ? value.format("HH:mm:ss") : null,
                                    })
                                }}
                            />
                        </FormItem>
                        <FormItem label={this.getText(12155)}>
                            <GenericSelectorPosStorages  {...this.props} multi
                                onChange={(value, typeList) => this.setReportParameters("PaymentDaily", { PosList: value.join(','), StorageList: typeList.join(',') })}
                                value={(this.state.PaymentDaily.PosList === '') ? [] : this.state.PaymentDaily.PosList.split(',')}
                            />
                            {/* {this.createCheckBox('PosList', Jax.get(this.props.data, TableIDs.genericSelectorPos + ".dataset", []).map((obj, index) => obj['code']).join(','))}
                            <Select key={"PosList"} style={{ width: '90%' }}
                                showsearch
                                filterOption={true}
                                optionFilterProp="valuefilter"
                                mode="multiple"
                                maxTagCount={4}
                                //placeholder="Please select"
                                //className={""}
                                //defaultValue={1}
                                onChange={(value) => this.setReportParameters("PaymentDaily", { PosList: value.join(',') })}
                                value={(this.state.PaymentDaily.PosList === '') ? [] : this.state.PaymentDaily.PosList.split(',')}
                            >
                                {listPos}
                            </Select> */}
                        </FormItem>

                        {/* <FormItem label={this.getText(12156)}>
                            {this.createCheckBox('StorageList', Jax.get(this.props.data, TableIDs.genericSelectorStorages + ".dataset", []).map((obj, index) => obj['code']).join(','))}
                            <Select key={"StorageList"} style={{ width: '90%' }}
                                showsearch
                                filterOption={true}
                                optionFilterProp="valuefilter"
                                mode="multiple"
                                maxTagCount={4}
                                //placeholder="Please select"
                                //className={""}
                                //defaultValue={1}
                                onChange={(value) => this.setReportParameters("PaymentDaily", { StorageList: value.join(',') })}
                                value={(this.state.PaymentDaily.StorageList === '') ? [] : this.state.PaymentDaily.StorageList.split(',')}
                            >
                                {listStorage}
                            </Select>
                        </FormItem> */}

                        <FormItem label={this.getText(12157)}>
                            {this.createCheckBox('PaymentType', Jax.get(this.props.data, TableIDs.genericSelectorPaymentTypes + ".dataset", []).map((obj, index) => obj['code']).join(','))}
                            <Select key={"PaymentType"} style={{ width: '90%' }}
                                showsearch
                                filterOption={true}
                                optionFilterProp="valuefilter"
                                mode="multiple"
                                maxTagCount={4}
                                //placeholder="Please select"
                                //className={""}
                                //defaultValue={1}
                                onChange={(value) => this.setReportParameters("PaymentDaily", { PaymentType: value.join(',') })}
                                value={(this.state.PaymentDaily.PaymentType === '') ? [] : this.state.PaymentDaily.PaymentType.split(',')}
                            >
                                {listPayments}
                            </Select>
                        </FormItem>

                        <FormItem label={this.getText(12158)} style={{ width: "100%" }}>
                            {this.createCheckBox('EmployeeList', Jax.get(this.props.data, TableIDs.genericSelectorEmployees + ".dataset", []).map((obj, index) => obj['code']).join(','))}
                            <Select key={"EmployeeList"} style={{ width: "90%" }}
                                showsearch
                                filterOption={true}
                                optionFilterProp="valuefilter"
                                mode="multiple"
                                maxTagCount={4}
                                //placeholder="Please select"
                                //className={""}
                                //defaultValue={1}
                                onChange={(value) => this.setReportParameters("PaymentDaily", { EmployeeList: value.join(',') })}
                                value={(this.state.PaymentDaily.EmployeeList === '') ? [] : this.state.PaymentDaily.EmployeeList.split(',')}
                            >
                                {listEmployee}
                            </Select>
                        </FormItem>

                        <ReportTypeButton
                            {...this.props}
                            params={this.state.PaymentDaily}
                            storagesField={'StorageList'}
                            tagsField={'ItemTagList'}
                            posField={'PosList'}
                            datesToFavorites={[
                                { field: 'LowerSelectionDate', label: this.getText(12153) },
                                { field: 'UpperSelectionDate', label: this.getText(12154) },
                            ]}
                            favoriteSave
                            xlsReportName={"reports/paymentsDailyExcel.xls"}
                        />

                        {/* <FormItem key={"reportName"} label={this.getText(12159)}>
                            <Select style={{ width: 250 }}
                                //size={"large"}
                                className={"reports/PaymentDaily.pdf"}
                                //combobox={null}
                                defaultValue={"pdf"}
                                onChange={(value) => {
                                    //const type = this.state.PaymentDaily.mRequestedReport;
                                    //console.log(type);
                                    //const str = (type === 0) ? '' : type.toString();
                                    //console.log(value,str);
                                    //this.setReportParameters("PaymentDaily", { reportName: "reports/PaymentDaily" + str + ".pdf"})}
                                    //this.setState({ ...this.state, type: value });
                                    this.setReportParameters("PaymentDaily", {
                                        reportName: "reports/paymentsDaily." + value,
                                        type: value
                                    });
                                }}
                            >
                                <Option key={"pdf"}>{this.getText(12160)}</Option>
                                <Option key={"xls"}>{this.getText(12161)}</Option>
                                <Option key={"docx"}>{this.getText(12162)}</Option>
                            </Select>
                        </FormItem>
                        <FormItem key={"submit"}>
                            <Button type={"primary"} onClick={() => {
                                //const type = this.state.RequestedReport;
                                this.generateReport.apply(this, ["PaymentDaily"])
                            }}>{this.getText(12163)}</Button>
                        </FormItem> */}
                    </Form>
                </Card>
            </div>
        );
    }
}
export default PaymentDailyReport;


